import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

async function getKonsulMasukByReg(regId: number | string) {
  const response = await http
    .getData(`/register/${regId}/surat-konsul-masuk`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getByRegister(regId: number | string) {
  const response = await http
    .getData(`/register/${regId}/surat-konsul`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function getListKonsulRanap(
  unitId: string,
  param: {
    sort: string;
    tglStart: string;
    tgllEnd: string;
  }
) {
  const response = await http
    .getDataParam(`/unit/${unitId}/pasien-konsul-ranap`, {
      params: {
        sort: param.sort,
        tgl_start: param.tglStart,
        tgl_end: param.tgllEnd
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data;
}

async function terimaByRanap(id, data) {
  const response = await http
    .putData(`/surat-konsul/${id}/terima-ranap`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function create(params: {
  register_id: string;
  pasien_rm: string;
  unit_pengirim_id: string;
  unit_tujuan_id: string;
  dr_pengirim_id: number;
  dr_tujuan_id?: number;
  ksm_tujuan_id?: string;
  diagnosis: string;
  masalah: string;
  konsultasi: string;
}) {
  const response = await http.postData(`/surat-konsul`, params).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response;
}

async function update(
  id,
  params: {
    register_id: string;
    pasien_rm: string;
    unit_pengirim_id: string;
    unit_tujuan_id: string;
    dr_pengirim_id: number;
    dr_tujuan_id?: number;
    ksm_tujuan_id?: string;
    diagnosis: string;
    masalah: string;
    konsultasi: string;
  }
) {
  const response = await http
    .putData(`/surat-konsul/${id}`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function jawab(
  konsulId,
  params: {
    dr_konsulan_id: number;
    soap_id: number;
    note: string;
    register_id: string;
    pasien_cm: string;
    unit_id: string;
    subjective: string;
    objective: string;
    assesment: string;
    plan: string;
    raber: 0 | 1;
  }
) {
  const response = await http
    .postData(`/surat-konsul/${konsulId}/reply`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function updateJawab(
  konsulId,
  params: {
    dr_konsulan_id: number;
    soap_id: number;
    note: string;
    register_id: string;
    pasien_cm: string;
    unit_id: string;
    subjective: string;
    objective: string;
    assesment: string;
    plan: string;
    raber: 0 | 1;
  }
) {
  const response = await http
    .putData(`/surat-konsul/${konsulId}/reply`, params)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

async function deleteJawab(konsulId) {
  const response = await http
    .deleteData(`/surat-konsul/${konsulId}/reply`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response;
}

export default {
  getKonsulMasukByReg,
  getByRegister,
  getListKonsulRanap,
  terimaByRanap,
  create,
  update,
  jawab,
  updateJawab,
  deleteJawab
};
